import { CompanyApp } from 'src/models/companyApp';

export const handleCheckAppAccess = (selectedApp: string, apps: CompanyApp[]) => apps.some((app) => app?.id?.includes(selectedApp) && app.hasAccess);
